module.exports = __webpack_public_path__ + "img/cert22.39c2fb0a.png";